export default "__VITE_ASSET__CsrG26JR__"